import { lazy } from "react";
import { Route } from "react-router-dom";

// Onboarding pages
const CompleteProfile = lazy(() => import("@/pages/onboarding/CompleteProfile"));
const AddProfile = lazy(() => import("@/pages/onboarding/AddProfile"));
const CompleteCoachProfile = lazy(() => import("@/pages/onboarding/CompleteCoachProfile"));
const CompleteClubProfile = lazy(() => import("@/pages/onboarding/CompleteClubProfile"));
const CompleteOrganizationProfile = lazy(() => import("@/pages/onboarding/CompleteOrganizationProfile"));
const FinalizeRegistration = lazy(() => import("@/pages/onboarding/FinalizeRegistration"));
const PlanSelection = lazy(() => import("@/pages/onboarding/PlanSelection"));
const RegisterWithPlan = lazy(() => import("@/pages/onboarding/RegisterWithPlan"));
const PaymentSuccess = lazy(() => import("@/pages/onboarding/PaymentSuccess"));
const BankTransferConfirmation = lazy(() => import("@/pages/onboarding/BankTransferConfirmation"));

/**
 * Onboarding routes - NOT wrapped in ProtectedRoute
 * since ProtectedRoute itself redirects here for incomplete profiles
 */
export const onboardingRoutes = (
  <>
    <Route path="/onboarding/complete-profile" element={<CompleteProfile />} />
    <Route path="/onboarding/add-profile" element={<AddProfile />} />
    <Route path="/onboarding/complete-coach-profile" element={<CompleteCoachProfile />} />
    <Route path="/onboarding/complete-club-profile" element={<CompleteClubProfile />} />
    <Route path="/onboarding/complete-organization-profile" element={<CompleteOrganizationProfile />} />
    <Route path="/onboarding/finalize" element={<FinalizeRegistration />} />
    <Route path="/onboarding/plans/:role" element={<PlanSelection />} />
    <Route path="/onboarding/register" element={<RegisterWithPlan />} />
    <Route path="/onboarding/register/:role" element={<RegisterWithPlan />} />
    <Route path="/onboarding/payment-success" element={<PaymentSuccess />} />
    <Route path="/onboarding/bank-transfer/:paymentId" element={<BankTransferConfirmation />} />
  </>
);
